/**
 * --- KONSEP: LAYANAN DASBOR (DASHBOARD SERVICE) ---
 * File ini bertugas mengumpulkan semua angka-angka penting (Ringkasan) 
 * yang tampil di halaman depan, seperti Total Pendapatan dan Stok Tipis.
 */
import { supabase } from '../lib/supabase';

export const dashboardService = {
  /**
   * --- LOGIKA: Mengambil Metrik Utama ---
   * Mengambil data dari berbagai tabel untuk dihitung ringkasannya.
   */
  async getDashboardMetrics() {
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id;

    // 1. Ambil data Produk untuk menghitung Stok dan Jumlah Barang
    let productsQuery = supabase
      .from("products")
      .select("price, stock_level, min_stock_level, name, sku")
      .eq("is_deleted", false);
      
    if (userId) {
      productsQuery = productsQuery.eq("user_id", userId);
    }
      
    const { data: products, error: prodError } = await productsQuery;
    if (prodError) throw prodError;

    // 2. Ambil 5 Transaksi Terakhir untuk ditampilkan di daftar 'Aktivitas Terbaru'
    let salesQuery = supabase
      .from("sales")
      .select("*");
      
    if (userId) {
      salesQuery = salesQuery.eq("sales_person_id", userId);
    }
    
    const { data: sales, error: salesError } = await salesQuery
      .order("created_at", { ascending: false })
      .limit(5);
    if (salesError) throw salesError;

    // 3. Ambil data Semua Total Penjualan untuk menghitung Pendapatan Keseluruhan
    let allSalesQuery = supabase
      .from("sales")
      .select("total");
      
    if (userId) {
      allSalesQuery = allSalesQuery.eq("sales_person_id", userId);
    }
    
    const { data: allSales, error: allSalesError } = await allSalesQuery;
    if (allSalesError) throw allSalesError;

    // --- PROSES PERHITUNGAN (KALKULASI) ---
    // Menghitung total uang masuk
    const totalSales = allSales.reduce((acc, curr) => acc + Number(curr.total), 0);
    // Menghitung berapa banyak jenis barang yang ada
    const activeSkus = products.length;
    // Menghitung berapa banyak barang yang stoknya sudah di bawah batas minimum
    const stockAlerts = products.filter((p) => p.stock_level <= p.min_stock_level).length;
    // Mengambil 3 contoh barang yang stoknya paling tipis
    const lowStockItems = products
      .filter((p) => p.stock_level <= p.min_stock_level)
      .slice(0, 3);

    // Mengembalikan (return) semua hasil hitungan ke halaman Dashboard
    return {
      totalSales,
      activeSkus,
      stockAlerts,
      recentSales: sales || [],
      lowStockItems: lowStockItems || [],
    };
  }
};
